import React, { useEffect, useState } from 'react'

function ViewTitle(props) {
  const [titleData, setTitleData] = useState({ TitleId: null, Title: '', Description: '' });

  useEffect(() => {
    setTitleData(props.TitleData);
  }, [props.TitleData])
  return (
    <>
      <div className="row">
        <div className="mb-3 add-product">
          <label className="form-label">Title</label>
          <input type="text" className="form-control" value={titleData.Title ?? ''} disabled />
        </div>
        <div className="mb-3 add-product">
          <label className="form-label">Description</label>
          <textarea className="form-control h-100" rows="5" value={titleData.Description ?? ''} disabled />
        </div>
      </div>
    </>
  )
}

export default ViewTitle